import { lazy } from 'solid-js'
import { ADD_PROPERTY_SECTION } from '../../components/lodgr/lodgr-add-property-template/add-property-sections-config-constants.js'
import { messages } from '../../pages/connect-property-page/connect-property-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/connect-property-page/connect-property-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/connect/property',
    requiredMode: 'host',
    showFooter: false,
    showFullWidthHeader: true,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
    // TENANT-5616: mounts the header's "Need Help?" button; the page reports which
    // screen it is on through `setWizardHelpStep`.
    wizardHelpSection: ADD_PROPERTY_SECTION.CONNECT_PROPERTY,
}
